import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePromotions from "common/datahooks/usePromotions";
import useWorkspaceDetails from "common/datahooks/useWorkspaceDetails";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

interface ReturnedSubscription<
  SubscriptionType extends
    | RentedSubscription
    | AgencySubscription
    | Subscription,
> {
  subscription: SubscriptionType;
  quantity: number;
}

export default function useSubscriptions() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { workspace } = useWorkspaceDetails(workspaceId);
  const { agencyPlan } = usePromotions();

  let rental: ReturnedSubscription<RentedSubscription>;
  let agency: ReturnedSubscription<AgencySubscription>;
  let user: ReturnedSubscription<Subscription>;

  if (workspace) {
    const { rental_subscription, subscription, license_count } = workspace;

    if (rental_subscription) {
      rental = {
        subscription: workspace.rental_subscription,
        quantity: rental_subscription.rented_count,
      };
    }
    if (subscription) {
      user = { subscription, quantity: license_count };
    }
  }
  if (agencyPlan) {
    const { subscription, license_count } = agencyPlan;
    agency = { subscription, quantity: license_count };
  }

  return {
    rental,
    agency,
    user,
  };
}
